module.exports = __webpack_public_path__ + "static/media/slider-image-03.8b6ad173.jpg";